import React from 'react'

import type { StepName } from '@/features/proposta/entities/Comprador/steps'
import { Render } from '@/shared/components/render-if'
import { Stepper, StepperIndicator, StepperTrigger, StepperItem } from '@/shared/components/ui/stepper'

export type StepCompradorLayoutProps = {
  steps: readonly StepName[]
  current: number
  onNext: () => void
  onBack: () => void
  onCancel: () => void
  children: React.ReactNode
}

export function StepCompradorLayout({ steps, current, children }: Readonly<StepCompradorLayoutProps>) {
  return (
    <div className="bg-foreground mx-auto mt-6 flex max-w-6xl flex-col">
      <Stepper value={current} className="mx-auto max-w-125 gap-1 px-4 py-4 lg:px-0">
        <Render.If condition={steps.length > 1}>
          {() => (
            <>
              {steps.map((key, i) => (
                <StepperItem key={key} step={i} className="flex-1">
                  <StepperTrigger asChild>
                    <StepperIndicator className="bg-border h-1 w-full" asChild>
                      <span className="sr-only" />
                    </StepperIndicator>
                  </StepperTrigger>
                </StepperItem>
              ))}
            </>
          )}
        </Render.If>
      </Stepper>
      <div className="mt-2">{children}</div>
    </div>
  )
}
